import './styles.css';
import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Sponsors from './components/Sponsors';
import Features from './components/Features';
import Agenda from './components/Agenda';
import Speakers from './components/Speakers';
import WhyAttend from './components/WhyAttend';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Register from './components/Register';
import Contact from './components/Contact';
import Footer from './components/Footer';
import TicketsPage from './components/TicketsPage';
import FlyerPopup from './components/FlyerPopup';

function LandingPage() {
  return (
    <>
      <Navbar />
      <FlyerPopup />
      <Hero />
      <Sponsors />
      <Features />
      <Agenda />
      <Speakers />
      <WhyAttend />
      <Testimonials />
      <Gallery />
      <Register />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleRouteChange = () => setPath(window.location.pathname);
    window.addEventListener('popstate', handleRouteChange);
    return () => window.removeEventListener('popstate', handleRouteChange);
  }, []);

  return (
    <div style={{ background: '#FFFFFF', minHeight: '100vh' }}>
      {path === '/tickets' ? <TicketsPage /> : <LandingPage />}
    </div>
  );
}

export default App;
